import React from "react";
import styles from "../map.module.scss";

const Heading = () => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.heading}>
          Join Our Global Community And Get Access <br />
          To A Better Way To Manage Your Money
        </div>
      </div>
    </>
  );
};

export default Heading;
